import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Rating } from '@mui/material'
import RichText from '../RichText'
import Profile from '../ContentfulEntries/Profile'
import { Testimonial as TestimonialType } from '../../types/landingPageV2'

interface Props {
  testimonial: TestimonialType
  quoteClass?: string
}

const Testimonial: React.FC<Props> = ({ testimonial, quoteClass }) => {
  const { classes, cx } = useStyles()

  return (
    <Box className={classes.box}>
      {testimonial.rating && (
        <Rating
          classes={{ icon: classes.icon }}
          readOnly
          precision={0.5}
          value={testimonial.rating}
        />
      )}
      {testimonial.quote && (
        <Box className={cx(classes.quote, quoteClass)}>
          <RichText rawBody={testimonial.quote.raw} />
        </Box>
      )}
      {testimonial.profile && (
        <Box className={classes.profile}>
          <Profile profile={testimonial.profile} />
        </Box>
      )}
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  icon: {
    color: theme.colors.orange['a100'],
  },
  profile: {
    marginTop: '0',
  },
  quote: {
    marginTop: '1.69em',

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      textAlign: 'center',
      width: 'unset',
    },
  },
}))

export default Testimonial
